module.exports = __webpack_public_path__ + "static/amr_foto-27a34881a3c2c00ddbe8d65c0d01a02f.jpg";